import { FeatureFlag } from '@revelio/core';

import { useUnleashFlag } from '../../../../shared/unleash-flags/use-unleash-flag';
import { RevelioPageId } from '../../components/PageConfigProvider/types';

const DISCOVERY_SCREENER_PAGES = new Set<string>([
  RevelioPageId.COMPANY_SCREENER_V2,
  RevelioPageId.GEOGRAPHY_SCREENER_V2,
  RevelioPageId.ROLE_SCREENER_V2,
]);

const TALENT_DISCOVERY_PAGES = new Set<string>([
  RevelioPageId.TALENT_DISCOVERY,
]);

/**
 * Returns whether the current page supports state (administrative) geography.
 * Checks per-page-group feature flags:
 * - Discovery screener pages → DiscoveryStateGeography
 * - Talent discovery → TalentDiscoveryStateGeography
 * - All other pages → GeographyUserPreference
 */
export const useSupportsStateGeography = (
  revelioPageId: string | undefined
): boolean => {
  const discoveryFlag = useUnleashFlag(FeatureFlag.DiscoveryStateGeography);
  const talentDiscoveryFlag = useUnleashFlag(
    FeatureFlag.TalentDiscoveryStateGeography
  );
  const geographyUserPreference = useUnleashFlag(
    FeatureFlag.GeographyUserPreference
  );

  if (revelioPageId && DISCOVERY_SCREENER_PAGES.has(revelioPageId)) {
    return discoveryFlag;
  }

  if (revelioPageId && TALENT_DISCOVERY_PAGES.has(revelioPageId)) {
    return talentDiscoveryFlag;
  }

  return geographyUserPreference;
};
